import { Routes } from '@angular/router';

export enum AlertsRouteNames {
  NEW_ALERT = 'new-alert',
  EDIT_ALERT = 'edit-alert',
}

export enum AlertsRouteIds {
  ALERT_ID = 'alertCode',
}

export const ALERTS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'listing',
  },
  {
    path: 'listing',
    loadComponent: () => import('@pages/alerts/alerts-list/alerts.page').then((p) => p.AlertsPage),
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: AlertsRouteNames.NEW_ALERT,
    loadComponent: () => import('@pages/alerts/alert-management/alert-management.page').then((p) => p.AlertManagementComponent),
    data: {
      breadcrumb: {
        label: 'ACTIONS.NEW_ALERT',
      },
    },
  },
  {
    path: `${AlertsRouteNames.EDIT_ALERT}/:${AlertsRouteIds.ALERT_ID}`,
    loadComponent: () => import('@pages/alerts/alert-management/alert-management.page').then((p) => p.AlertManagementComponent),
    data: {
      breadcrumb: {
        label: 'ACTIONS.EDIT_ALERT',
      },
    },
  },
];
